@if (formJson) {
  <ptl-form-as-json [formJson]="formJson"></ptl-form-as-json>
}
